/* route → page. Each page module registers itself: PAGES.home = { crumb: () => "Overview", C: Home } */
import type { FC } from "react";

export type PageProps = { param: string | null; tab: string | null };
export type PageDef = { crumb: (param: string | null, tab: string | null) => string; C: FC<PageProps> };
export const PAGES: Record<string, PageDef> = {};
